import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
}), 'ExposureNeg1Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ExposureNeg1Sharp.js
// module id = 3467
// module chunks = 2